import { FreeGiftRule } from '@emico-hooks/cart-fragment'

import { CustomerCoupon } from './customerVouchers.query'
import { useCartItems } from '../../cart/CartPage/useCartItems'
import parseMagentoDateTime from '../../utils/parseMagentoDateTime'
import { useGetCustomerVouchers } from '../../vouchers/useGetCustomerVouchers'

const sortByValidUntilDate = (
    a: CustomerCoupon | FreeGiftRule,
    b: CustomerCoupon | FreeGiftRule,
) => {
    const timeMillisA = parseMagentoDateTime(
        a.validUntil || createValidUntilDate(),
    ).getTime()
    const timeMillisB = parseMagentoDateTime(
        b.validUntil || createValidUntilDate(),
    ).getTime()

    return timeMillisA - timeMillisB
}

const createValidUntilDate = () => {
    const date = new Date()
    date.setFullYear(date.getFullYear() + 10)
    return new Date(date.toISOString()).toISOString()
}

export const useGetAllUnclaimedVouchers = () => {
    const { freeGifts: cartRules } = useCartItems()
    // Only valid rules for current user (customergroup)
    const unClaimedGiftRules = cartRules?.filter(
        (rule) => rule.isValidCustomerGroup,
    )

    const { loading, salesRuleVouchers, freeGiftVouchers, customerCoupons } =
        useGetCustomerVouchers({ fetchPolicy: 'cache-first' })

    // Filter srs free gifts (not cart items):
    const freeGifts = [...freeGiftVouchers.filter((gift) => !gift.isCartItem)]

    const vouchers = [...salesRuleVouchers, ...customerCoupons]

    const unclaimedVouchers = [
        ...vouchers,
        ...(unClaimedGiftRules ?? []),
        ...(freeGifts ?? []),
    ]

    return { loading, unclaimedVouchers }
}

export const Vouchers = ({
    limit,
    children,
}: {
    limit?: number | undefined
    children: (
        loading: boolean,
        vouchers: Array<CustomerCoupon | FreeGiftRule>,
    ) => JSX.Element
}) => {
    const { loading, unclaimedVouchers } = useGetAllUnclaimedVouchers()
    // Sort on validUntil date:
    const vouchers = (unclaimedVouchers ?? [].sort(sortByValidUntilDate)).slice(
        0,
        limit,
    )
    return children(loading, vouchers)
}
